import React from 'react';
import request from 'arcdynamic-request';
import Alert from '../Alert';
import Input from '../Input';
import {backendServicesUrl} from '../../consts/env';

export default class Login extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			error: null,
			isBusy: null,
			username: '',
			password: '',
		};

		this.login = this.login.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	login(e) {
		e.preventDefault();

		this.setState({
			isBusy: true,
			error: null,
		});

		request(backendServicesUrl, {
			service: 'arcimedes',
			action: 'Authentication.login',
			params: [this.state.username, this.state.password],
		}).then(res => {
			if (res && res.success) {
				this.props.setUser(true);

				this.setState({
					isBusy: null,
					error: null,
				})
			} else {
                this.props.setUser(false);
				this.setState({
					isBusy: null,
					error: res && res.message ? res.message : 'Unspecified error',
				})
			}
		});
	}

	handleChange(e) {
		this.setState({[e.currentTarget.name]: e.currentTarget.value});
	}

	render() {
		return (
			<main className='login-page'>
				<div className='login-card'>
					<div className='login-logo'>
						<img 
							src={`/img/inline-dark-logo.png`} 
							alt='Summit Logo' 
							style={{ maxWidth: '90%', height: 'auto', display: 'block' , borderBottom: '1px solid #E0E0E0'}}
						/>
					</div>
					
					<h1 className='login-title'>Welcome back 👋</h1>
					<p className='login-subtitle'>Please sign in to continue to the dashboard.</p>
					
					{
						this.state.error ? (
							<Alert type='error'>{this.state.error}</Alert>
						) : null
					}
					
					<form onSubmit={this.login} className='login-form'>
						<div className='form-field'>
							<label htmlFor='username'>Username</label>
							<Input 
								autocomplete='username' 
								autoFocus={true} 
								type='text' 
								name='username' 
								id='username'
								value={this.state.username} 
								placeholder='Enter your username' 
								onChange={this.handleChange}
							/>
						</div>
						
						<div className='form-field'>
							<label htmlFor='password'>Password</label>
							<Input 
								autocomplete='current-password' 
								type='password' 
								name='password' 
								id='password'
								value={this.state.password} 
								placeholder='Enter your password' 
								onChange={this.handleChange}
							/>
						</div>
						
						<button className='login-button' data-busy={this.state.isBusy}>
							Login
						</button>
					</form>
				</div>
				
				<p className='login-footer'>© 2026 Summit. All rights reserved. | summiter.com</p>
			</main>
		);
	}
}
